/** @jsxImportSource @emotion/react */
import React, { forwardRef } from "react";
import "../../../pages/Trade/index.css";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { Token } from "../../../store/global/TokenEnum";
import { Amount } from "../../../types/amount";
import { CurrencyInput } from "../../general/CurrencyInput/CurrencyInput";
import { BalancePercentageOptionsEnum } from "./BalancePercentages";
import { debounce } from "lodash-es";

export interface AmountInputProps {
  symbol: Token;
  setBalancePercentageActive: React.Dispatch<
    React.SetStateAction<BalancePercentageOptionsEnum | undefined>
  >;
}

const AmountInput = forwardRef<HTMLInputElement, AmountInputProps>(
  ({ symbol, setBalancePercentageActive }, ref) => {
    const selectedToken = GlobalStore.useState(s => {
      return s.takerTokens.find(e => e.token === symbol);
    });

    const updateStore = (value: Amount) => {
      setBalancePercentageActive(undefined);
      GlobalStore.update(s => {
        s.takerTokens = s.takerTokens.map(e => {
          if (e.token === symbol) {
            e.amount = value;
          }
          return e;
        });
      });
    };

    const debounceUpdateStore = debounce(updateStore, 250);

    return (
      <CurrencyInput
        ref={ref}
        value={selectedToken?.amount ?? new Amount("0")}
        onValueChange={value => {
          debounceUpdateStore(value);
        }}
        onBlurred={value => {
          // Process the value immediately when the user leaves the input
          if (value) {
            debounceUpdateStore.flush();
          }
        }}
        symbol={symbol}
        id="o2o-top"
        data-testid={`${symbol}-amount-input`}
      />
    );
  }
);
export default React.memo(AmountInput);
